// Status and reason codes sent by the server at login (login.user.acl) and refreshed by GET /acl/codes.
// acl = { status: [code], reason: [code], custom: { [companyId]: { status: [code], reason: [code] } } }
// code = { value, label, group, platforms }
let acl = null;
let labels = null;

export const setAcl = (value) => {
  const next = value && Array.isArray(value.status) && Array.isArray(value.reason) ? value : null;
  if (next !== acl) {
    acl = next;
    labels = null;
  }
};

export const hasAcl = () => acl !== null;

const unique = (codes) => {
  const seen = new Set();
  return codes.filter((code) => !seen.has(code.value) && seen.add(code.value));
};

// default codes, plus the custom ones of one company, or of every company for screens that span companies
const codesOf = (kind, { companyId, allCompanies } = {}) => {
  const custom = acl.custom || {};
  const extra = allCompanies ? Object.values(custom).flatMap((company) => company[kind] || []) : custom[companyId]?.[kind] || [];
  return unique([...(acl[kind] || []), ...extra]);
};

const onPlatform = (codes, platform) => (platform ? codes.filter((code) => !code.platforms || code.platforms.includes(platform)) : codes);

export const aclStatusOptions = (options = {}) => onPlatform(codesOf("status", options), options.platform).map(({ value, label }) => ({ code: value, text: label }));

// a record stores the reason as its text, so the text is the option's value
export const aclReasonOptions = (options = {}) => {
  const seen = new Set();
  return onPlatform(codesOf("reason", options), options.platform)
    .filter(({ label }) => !seen.has(label) && seen.add(label))
    .map(({ label }) => ({ code: label, text: label }));
};

export const aclStatusLabel = (code) => {
  if (!acl) return "";

  if (!labels) {
    labels = new Map();
    [...acl.status, ...Object.values(acl.custom || {}).flatMap((company) => company.status || [])].forEach((item) => labels.set(item.value, item.label));
  }
  return labels.get(String(code)) || "";
};

// a key ("123") or a text ("TM") to the stored text, or "" when it is not a reason this company may use
export const resolveAclReason = (value, options = {}) => {
  if (!acl || value === undefined || value === null) return "";

  const text = String(value);
  const codes = codesOf("reason", options);
  const found = codes.find((code) => code.value === text) || codes.find((code) => code.label === text);
  return found ? found.label : "";
};
